
  import Vue from "vue";
  import PwaCompetitionIndividualRow from "@/components/competitions/PwaCompetitionIndividualRow.vue";
  import {COMPETITION_TYPE_IDS} from "@/utils/competition";

  export default Vue.extend({
    name: "pwa-competition-individual-list",
    components: {
      PwaCompetitionIndividualRow,
    },
    props: {
      competitions: {
        type: Array,
        required: true,
      },
      limitBlock: {
        type: Number,
        required: false,
        default: 4,
      },
      currentUserName: {
        type: String,
        required: false,
      },
      relatedGameId: {
        type: [String,Number],
        required: false,
        default: null,
      },
    },
    data() {
      return {
        competitionsList: [] as any[],
        hasMoreCompetitions: false,
      }
    },
    mounted() {
      this.updateCompetitions(this.competitions, true);
    },
    methods: {
      async onSeeMoreClick() {
        if(!this.isLoggedIn){
          this.goToSignup();
        }else{
          try {
            this.showLoader(true);
            const params: Record<string, string|number> = {
              limit: this.limitBlock,
              offset: this.competitionsList.length,
              type_id: COMPETITION_TYPE_IDS.INDIVIDUAL,
            };

            if (this.relatedGameId) {
              params.related_game_id = this.relatedGameId;
            }

            const {data} = await this.$http.user.getUserCompetitionsHistory(this.currentUserName, params);
            const individuals: Record<string, any>[] = data.data || [];
            this.updateCompetitions(individuals);
          } catch (error) {
            this.showToastError(this.$t('139'), this.$t('140'));
          } finally {
            this.showLoader(false);
          }

        }
      },
      updateCompetitions(competitions: any[], forceReset = false): void {
        if (this.competitionsList.length > 0 && !forceReset) {
          this.competitionsList = [...this.competitionsList, ...competitions]
        } else {
          this.competitionsList = competitions;
        }

        this.hasMoreCompetitions = competitions.length >= this.limitBlock;
      },
    },
    watch: {
      competitions() {
        this.updateCompetitions(this.competitions, true);
      }
    }
  });
